module.exports = __webpack_public_path__ + "static/media/buy-hero-button.59adf28a.png";